<template>

<app-page>

	<app-page-head :title="title" back="Accesses">

		<app-page-head-action v-if="is.new" :disabled="!isDirty" icon="undo" tooltip="Undo changes" v-on:click.native="onUndoClick" />
		<app-page-head-action v-if="is.new || is.existing" :loading="is.saving" :disabled="!isDirty || !isValid" icon="save" tooltip="Save changes" v-on:click.native="onSaveClick" />
		<app-page-head-action route="Access.Delete" v-if="!isNew && (model.level > 1 || $store.getters['user'].access.level === 1)" :disabled="isNew" :danger="true" icon="delete" tooltip="Delete" />
		
	</app-page-head>

	<app-page-content :is-grown="true">

		<app-page-content-section :is-padded="true" is-divided="true">

			<template v-if="isNew">

				<app-input-text :loading="is.checking" v-model="model.user.email" :validation="$v.model.user.email" label="Email" placeholder="Enter email address" notes="Please enter the e-mail address of the user you wish to grant access to and the system will check if they already have an account." />
			
				<template v-if="is.new">

					<app-input-text v-model="model.user.name" :validation="$v.model.user.name" label="Name" placeholder="Enter name" :maxlength="32" notes="The user will receive an e-mail with their login credentials." />
					<app-input-text v-model="extra.password" :validation="$v.extra.password" label="Password" placeholder="Enter password" notes="Your password should be at least 12 characters long." />
					<app-input-text v-model="extra.password2" :validation="$v.extra.password2" label="Confirm Password" placeholder="Repeat password" />

				</template>

				<template v-if="is.existing">

					<app-input-text :disabled="true" v-model="model.user.name" :validation="$v.model.user.name" label="Name" placeholder="Enter name" :maxlength="32" />

				</template>

				<app-notice v-if="is.added">This user already has access granted to this guide.</app-notice>

				<template v-if="!is.added">
				
					<app-input-toggle label="Level" :options="levelOptions" :fullWidth="true" v-model="model.level" />

				</template>

			</template>

			<template v-if="!isNew">

				<app-input-text :disabled="true" v-model="model.user.email" :validation="$v.model.user.email" label="Email" placeholder="Enter email address" />
				<app-input-text :disabled="true" v-model="model.user.name" :validation="$v.model.user.name" label="Name" placeholder="Enter name" :maxlength="32" />

				<app-input-toggle label="Level" :options="levelOptions" :fullWidth="true" v-model="model.level" v-if="model.level > 1" />
				<app-input-toggle label="Level" :options="levelOwnerOptions" :fullWidth="true" v-model="model.level" v-if="model.level === 1" />

			</template>

		</app-page-content-section>

		<app-page-content-section :is-padded="true" is-divided="true" v-if="model.level > 1">

			<app-input-toggle label="Categories" :options="permissionOptions" :fullWidth="true" v-model="model.permissions.categories" />
			<app-input-toggle label="Groups" :options="permissionOptions" :fullWidth="true" v-model="model.permissions.groups" />
			<app-input-toggle label="Items" :options="permissionOptions" :fullWidth="true" v-model="model.permissions.items" />
			<app-input-toggle label="Locations" :options="permissionOptions" :fullWidth="true" v-model="model.permissions.locations" />
			<app-input-toggle label="Templates" :options="permissionOptions" :fullWidth="true" v-model="model.permissions.templates" />
			<app-input-toggle label="Terms" :options="permissionOptions" :fullWidth="true" v-model="model.permissions.terms" />

		</app-page-content-section>

		<app-page-content-section :is-padded="true" is-divided="true" v-if="model.level === 2">
			
			<app-input-toggle label="Requests" :options="permissionAdminOptions" :fullWidth="true" v-model="model.permissions.requests" />
			<app-input-toggle label="Embed" :options="permissionAdminOptions" :fullWidth="true" v-model="model.permissions.embed" />
			<app-input-toggle label="Share" :options="permissionAdminOptions" :fullWidth="true" v-model="model.permissions.share" />
			<app-input-toggle label="Access" :options="permissionAdminOptions" :fullWidth="true" v-model="model.permissions.access" />
			<app-input-toggle label="Settings" :options="permissionAdminOptions" :fullWidth="true" v-model="model.permissions.settings" />

		</app-page-content-section>

	</app-page-content>

	<app-page-foot />

</app-page>

</template>

<script>

import mixForm from '@/mixin/form'
import { required, maxLength, minLength, minValue, email } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	data: function() {

		return {
			is: {
				checking: false,
				checked: false,
				added: false,
				new: false,
				existing: false
			},
			model: {
				id: 0,
				user: {
					name: '',
					email: ''
				},
				permissions: {
					categories: 3,
					groups: 3,
					items: 3,
					locations: 3,
					templates: 3,
					terms: 3,
					requests: 3,
					embed: 3,
					share: 3,
					access: 3,
					settings: 3
				},
				level: 0
			},
			extra: {
				password: '',
				password2: ''
			},
			permissionOptions: {
				0: 'None',
				1: 'Read only',
				2: 'Edit only',
				3: 'Full'
			},
			permissionAdminOptions: {
				0: 'None',
				3: 'Full'
			},
			levelOptions: {
				1: 'Owner',
				2: 'Admin',
				3: 'Editor'
			},
			levelOwnerOptions: {
				1: 'Owner'
			},
			param: 'access',
			noun: 'Access',
			store: 'access'
		}

	},

	validations: function() {

		var validations = {
			model: {
				user: {
					name: {
						required,
						maxLength: maxLength(32)
					},
					email: {
						required,
						email
					}
				},
				level: {
					required,
					minValue: minValue(1)
				}
			},
			extra: {
				password: {},
				password2: {}
			}
		}

		if (this.is.new) {

			validations.extra.password = {
				required,
				minLength: minLength(12),
			}

			validations.extra.password2 = {
				sameAsPassword: function() {

					return this.extra.password === this.extra.password2

				}.bind(this)
			}

		}

		return validations
	},

	computed: {

		email: function() {

			return this.model.user.email

		}

	},

	watch: {

		email: function() {
		
			if (this.$v.model.user.email.$invalid) {

				this.is.checking = false
				this.is.checked = false
				this.is.new = false 
				this.is.existing = false
				this.is.added = false

			} else {

				this.$api.cancel()

				this.is.checking = true

				this.$api.get('access/check', {
					email: this.model.user.email
				}).then(function(json) {

					this.is.checking = false
					this.is.checked = true
					this.is.new = false 
					this.is.existing = false
					this.is.added = false

					if (json.user) {

						this.is.existing = true

						if (json.hasAccess) {

							this.is.added = true
								
						}

						this.model.user.name = json.user.name

					} else {

						this.is.new = true

						var password = this.$util.generateKey(12, 'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ')

						this.extra.password = password
						this.extra.password2 = password

						this.model.user.name = ''
					
					}

				}.bind(this))

			}

		}

	}

}

</script>

<style scoped>

</style>
